import { memo } from "react"
import styled from "styled-components"

const IconWrapper = styled.svg`
  position: absolute;
  top: 45px;
  right: -100px;
`

export const IconEventType = memo(() => {
  return (
    <IconWrapper xmlns="http://www.w3.org/2000/svg" width="333" height="333" viewBox="0 0 333 333" fill="none">
      <g opacity="0.1">
        <path
          d="M110.977 69.3721H41.6016"
          stroke="#6062CB"
          stroke-width="22.375"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M277.5 97.1255H124.875C117.216 97.1255 111 90.9095 111 83.2505V55.5005C111 47.8415 117.216 41.6255 124.875 41.6255H277.5C285.159 41.6255 291.375 47.8415 291.375 55.5005V83.2505C291.375 90.9095 285.159 97.1255 277.5 97.1255Z"
          stroke="#6062CB"
          stroke-width="22.375"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M110.977 166.498H41.6016"
          stroke="#6062CB"
          stroke-width="22.375"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M277.5 194.251H124.875C117.216 194.251 111 188.035 111 180.376V152.626C111 144.967 117.216 138.751 124.875 138.751H277.5C285.159 138.751 291.375 144.967 291.375 152.626V180.376C291.375 188.035 285.159 194.251 277.5 194.251Z"
          stroke="#6062CB"
          stroke-width="22.375"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M277.5 291.377H124.875C117.216 291.377 111 285.161 111 277.502V249.752C111 242.093 117.216 235.877 124.875 235.877H277.5C285.159 235.877 291.375 242.093 291.375 249.752V277.502C291.375 285.161 285.159 291.377 277.5 291.377Z"
          stroke="#6062CB"
          stroke-width="22.375"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M110.977 263.625H55.4766C47.8176 263.625 41.6016 257.409 41.6016 249.75V41.6255"
          stroke="#6062CB"
          stroke-width="22.375"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </IconWrapper>
  )
})
